import routes from '@/routes/index';
import { Suspense } from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { useRoutes } from 'react-router-dom';
import CookieNotice from './components/CookiesConsents';
import Loader from './components/Loader';
import { useSiteSettings } from './components/SiteSettings';
import { LanguageProvider } from '@/contexts/LanguageContext';

const App = () => {
  const element = useRoutes(routes);
  const { settings } = useSiteSettings();
  return <>
    <LanguageProvider>
      <GoogleReCaptchaProvider
        reCaptchaKey={settings.general?.captcha?.siteKey}
        language='tr'
      >
        <Suspense fallback={<Loader isLoading />}>
          {element}
        </Suspense>
      </GoogleReCaptchaProvider>
      <CookieNotice />
    </LanguageProvider>
  </>;
};

export default App;
